(function() {
    'use strict';
    /**
     *
     * With data-role="datePickerWith3Selects" -> Enhance date input text in 3 select elements (day, month, year). (month in text)
     * With data-role="datePickerWith2Selects" -> Enhance date input text in 2 select elements (month, year). (month in number)
     *
     * * data-role="datePickerWith3Selects"
     * ----------
     * It should be define as
     *      <input data-name="" type="text" data-role="datePickerWith3Selects"/> //It contains text date as dd-MM-YYYY
     *
     *
     * It will enhance to
     *
     *          <input type="hidden"/> //It will contain text date as dd-MM-YYYY
     *          <select>day</select>
     *          <select>month</select>
     *          <select>year</select>
     *
     *
     * * data-role="datePickerWith2Selects"
     * ----------
     * It should be define as
     *      <input data-name="" type="text" data-role="datePickerWith2Selects"/> //It contains text date as MM-YYYY
     *
     *
     * It will enhance to
     *
     *          <input type="hidden"/> //It will contain text date as MM-YYYY
     *          <select>month</select>
     *          <select>year</select>
     *
     *
     * @param {Jquery} $el
     * @param {Object} options -yearLimit(mandatory): examples: 1920, 2050, ...(year combo shows years from actual year to the year limit)
     * @return {Jquery} $el
     */
    Odigeo.UIElements.enhanceDateWithSelects = function($el, options) {
        var i;
        var $days;
        var $month;
        var $year;
        var currentYear;
        var yearLimit = Number(options.yearLimit);

        $el = ($el instanceof $) ? $el : $($el);

        // Check if $el has everything ok to be created
        if (Odigeo._.isEmpty($el) ||
            $el.attr('data-skip-enhance') === 'true' ||
            !yearLimit ||
            !Odigeo._.includes(['datePickerWith3Selects', 'datePickerWith2Selects', 'datePickerWith2Inputs'], $el.attr('data-role'))) {
            return;
        }

        var appendDatePickerWith3Selects = function(dateElements) {
            var $row = $('<div class="odf-row odf-select-container od-datepicker-mobile"></div>');
            var format = $el.data('format').split(',');

            for (var i = format.length - 1; i >= 0; i--) {
                if (dateElements[format[i]]) {
                    if (options.isMobile) {
                        $row.append(dateElements[format[format.length - 1 - i]]);
                    } else {
                        dateElements[format[i]].insertAfter($el);
                    }
                }
            }
            if (options.isMobile) {
                $row.insertBefore($el);
            }
        };

        $el.checkInputValues = function() {
            var data = {};
            if ($el.attr('data-role') === 'datePickerWith3Selects') {
                data = {
                    year: $year.val(),
                    month: $month.val(),
                    day: $days.val(),
                };
            } else {
                data = {
                    year: $year.val(),
                    month: $month.val(),
                };
            }
            return data;
        };

        // Initialize
        $el.attr('data-skip-enhance', true);
        $el.addClass('hidden', true);

        // 3 COMBOS ROLE as used in passenger desktop
        if ($el.attr('data-role') === 'datePickerWith3Selects') {
            // Day select
            var selectMobile = 'odf-input odf-select odf-mobile-input odf-mobile-select';
            $days = $('<select class="' + (options.isMobile ? selectMobile : 'odf-select-xs') + ' select_day birth_date_day"></select>')
                .append($('<option></option>').attr({'value': -1}).html((options.isMobile
                    ? Odigeo.UIElements.translations.datepicker.day : '-')));
            for (i = 1; i <= 31; i++) {
                $days.append($('<option></option>').attr({'value': i < 10 ? '0' + i : i}).html(i));
            }

            // Month select
            $month = $('<select class="' + (options.isMobile ? selectMobile : 'odf-select-m') + ' select_month birth_date_month"></select>')
                .append($('<option></option>').attr({'value': -1}).html((options.isMobile
                    ? Odigeo.UIElements.translations.datepicker.month : '-')));
            Odigeo._.each(Odigeo.Utils.months, function(month, index) {
                $month.append($('<option></option>').attr({'value': index + 1 < 10 ? '0' + (index + 1) : index + 1}).html(month));
            });

            // Year select.
            $year = $('<select class="' + (options.isMobile ? selectMobile : 'odf-select-s') + ' select_year birth_date_year"></select>')
                .append($('<option></option>').attr({'value': -1}).html((options.isMobile
                    ? Odigeo.UIElements.translations.datepicker.year : '-')));
            currentYear = (new Date()).getFullYear();
            $year.append($('<option></option>').attr({'value': currentYear}).html(currentYear));
            while (currentYear !== yearLimit) {
                if (currentYear < yearLimit) {
                    ++currentYear;
                } else {
                    --currentYear;
                }
                $year.append($('<option></option>').attr({'value': currentYear}).html(currentYear));
            }

            // Append combos
            var selectors = {
                year: $year,
                month: $month,
                day: $days,
            };
            appendDatePickerWith3Selects(selectors);
            if (!options.isMobile) {
                $year.wrap('<span class="odf-select-wrapper"></span>');
                $month.wrap('<span class="odf-select-wrapper od-datepicker-wrapper-margin"></span>');
                $days.wrap('<span class="odf-select-wrapper od-datepicker-wrapper-margin"></span>');
            } else {
                var arrow = '<span class="odf-input-icon odf-icon odf-icon-arrow-down od-selector-arrow"></span>';
                $year.wrap('<div class="odf-col odf-col-no-gutter"></div>');
                $month.wrap('<div class="odf-col odf-col-no-gutter"></div>');
                $days.wrap('<div class="odf-col odf-col-no-gutter"></div>');
                $(arrow).insertAfter($year);
                $(arrow).insertAfter($days);
                $(arrow).insertAfter($month);
                var format = $el.data('format').split(',');
                selectors[Odigeo._.first(format)].parent().addClass('od-datepicker-right-padding');
                selectors[Odigeo._.last(format)].parent().addClass('od-datepicker-left-padding');
            }

            // Binds change event and update input
            $days.add($month).add($year).on('change', function() {
                if ($year.val() === '-1' || $month.val() === '-1' || $days.val() === '-1') {
                    $el.val('');
                } else {
                    $el.val($year.val() + '-' + $month.val() + '-' + $days.val());
                }
            });

            // 2 COMBOS ROLE as used in payment desktop
        } else if ($el.attr('data-role') === 'datePickerWith2Selects') {
            // Month select
            $month = $('<select class="odf-select-m select_month"></select>')
                .append($('<option></option>').attr({'value': -1}).html('-'));
            for (i = 1; i <= 12; i++) {
                $month.append($('<option></option>').attr({'value': i < 10 ? '0' + i : i}).html(i));
            }

            // Year select
            $year = $('<select class="odf-select-s select_year"></select>')
                .append($('<option></option>').attr({'value': -1}).html('-'));
            currentYear = (new Date()).getFullYear();
            $year.append($('<option></option>').attr({'value': currentYear}).html(currentYear));
            while (currentYear !== yearLimit) {
                if (currentYear < yearLimit) {
                    ++currentYear;
                } else {
                    --currentYear;
                }
                $year.append($('<option></option>').attr({'value': currentYear}).html(currentYear));
            }

            // Append combos
            $year.insertAfter($el);
            $year.wrap('<span class="od-comboyear-input-wrapper"></span>');
            $('<b class=\'od-comboyear-separator\'>&#47;</b>').insertAfter($el);
            $month.insertAfter($el);
            $month.wrap('<span class="od-combomonth-input-wrapper"></span>');

            // Binds change event and update input
            $month.add($year).on('change', function() {
                if ($year.val() === '-1' || $month.val() === '-1') {
                    $el.val('');
                } else {
                    $el.val($year.val() + '-' + $month.val() + '-01');
                }
            });
            $el.on('cleanCombos', function() {
                $month.add($year).val('-1').trigger('change');
            });
        } else if ($el.attr('data-role') === 'datePickerWith2Inputs') {
            // Month input
            $month = $('<input type="text" placeholder="mm" maxlength="2" />');

            // Year input
            $year = $('<input type="text" placeholder="aa" maxlength="2" />');

            // Append combos
            $year.insertAfter($el);
            $year.wrap('<span class="od-comboyear-input-wrapper"></span>');
            $('<b class=\'ob-comboyear-separator\'>&#47;</b>').insertAfter($el);
            $month.insertAfter($el);
            $month.wrap('<span class="od-combomonth-input-wrapper"></span>');

            // Binds change event and update input
            $month.add($year).on('change', function() {
                $el.val('20' + $year.val() + '-' + $month.val());
            });
        }

        // Apply blur on enhanced input when blur in any select element
        if (!Odigeo._.isUndefined($days)) {
            $days.on('blur', function() {
                $el.blur();
            });
        }

        if (!Odigeo._.isUndefined($month)) {
            $month.on('blur', function() {
                $el.blur();
            });
        }

        if (!Odigeo._.isUndefined($year)) {
            $year.on('blur', function() {
                $el.blur();
            });
        }
        return $el;
    };

    Odigeo.UIElements.enhanceDateWithCobaltSelects = function($el, options) {
        var i;
        var $days;
        var $month;
        var $year;
        var $yearSelect;
        var $monthSelect;
        var $daysSelect;
        var selectIcon;
        var currentYear;
        var yearLimit = Number(options.yearLimit);

        $el = $el instanceof $ ? $el : $($el);

        // Check if $el has everything ok to be created
        if (Odigeo._.isEmpty($el) ||
            $el.attr('data-skip-enhance') === 'true' ||
            !yearLimit ||
            !Odigeo._.includes(['datePickerWith3Selects', 'datePickerWith2Selects', 'datePickerWith2Inputs'], $el.attr('data-role'))) {
            return;
        }

        var appendDatePickerWith3Selects = function(dateElements) {
            var format = $el.data('format').split(',');

            for (var i = format.length - 1; i >= 0; i--) {
                if (dateElements[format[i]]) {
                    dateElements[format[i]].insertAfter($el);
                }
            }
        };

        var getSelectLabel = function(label) {
            return `<label class="prisma-label prisma-label-select odf-text-nowrap ">${label}</label>`;
        };


        $el.checkInputValues = function() {
            var data = {};
            if ($el.attr('data-role') === 'datePickerWith3Selects') {
                data = {
                    year: $year.val(),
                    month: $month.val(),
                    day: $days.val(),
                };
            } else {
                data = {
                    year: $year.val(),
                    month: $month.val(),
                };
            }
            return data;
        };

        // Initialize
        $el.attr('data-skip-enhance', true);
        $el.addClass('od-not-show-field-cobalt', true);

        // Lables
        $el.nextAll('.prisma-label').addClass('odf-hidden');
        $el.parent()
            .prevAll('.form_field_label')
            .removeClass('odf-hidden');


        // 3 COMBOS ROLE as used in passenger desktop
        if ($el.attr('data-role') === 'datePickerWith3Selects') {
            // Day select
            $daysSelect = $('<select class="prisma-select prisma-input select_day birth_date_day"></select>').append(
                $('<option></option>')
                    .attr({value: -1})
                    .html('-')
            );
            for (i = 1; i <= 31; i++) {
                $daysSelect.append($('<option></option>').attr({'value': i < 10 ? '0' + i : i}).html(i));
            }

            // Month select
            $monthSelect = $('<select class="prisma-select prisma-input select_month birth_date_month"></select>').append(
                $('<option></option>')
                    .attr({value: -1})
                    .html('-')
            );
            Odigeo._.each(Odigeo.Utils.months, function(month, index) {
                $monthSelect.append($('<option></option>').attr({'value': index + 1 < 10 ? '0' + (index + 1) : index + 1}).html(month));
            });

            // Year select.
            $yearSelect = $('<select class=" prisma-select prisma-input select_year birth_date_year"></select>').append(
                $('<option></option>')
                    .attr({value: -1})
                    .html('-')
            );
            currentYear = (new Date()).getFullYear();
            $yearSelect.append($('<option></option>').attr({'value': currentYear}).html(currentYear));
            while (currentYear !== yearLimit) {
                if (currentYear < yearLimit) {
                    ++currentYear;
                } else {
                    --currentYear;
                }
                $yearSelect.append($('<option></option>').attr({'value': currentYear}).html(currentYear));
            }

            selectIcon = '<span class="prisma-input-icon odf-icon-xl odf-icon odf-icon-arrow-down"></span>';
            $year = $('<div class="prisma-select-wrapper"></div>')
                .append(getSelectLabel(Odigeo.UIElements.translations.datepicker.yearLabel))
                .append($yearSelect)
                .append(selectIcon);
            $month = $('<div class="prisma-select-wrapper"></div>')
                .append(getSelectLabel(Odigeo.UIElements.translations.datepicker.monthLabel))
                .append($monthSelect)
                .append(selectIcon);
            $days = $('<div class="prisma-select-wrapper"></div>')
                .append(getSelectLabel(Odigeo.UIElements.translations.datepicker.dayLabel))
                .append($daysSelect)
                .append(selectIcon);

            // Append combos
            var selectors = {
                year: $year,
                month: $month,
                day: $days,
            };
            appendDatePickerWith3Selects(selectors);

            $year.wrap('<div class="od-cobalt-form-col od-cobalt-form-col-year odf-space-inner-left-s"><div>');
            $month.wrap('<div class="od-cobalt-form-col od-cobalt-form-col-month odf-space-inner-left-s"><div>');
            $days.wrap('<div class="od-cobalt-form-col od-cobalt-form-col-day odf-space-inner-left-s"><div>');
            $year.wrap('<div class="prisma-input-group prisma-input-padding"><div>' );
            $month.wrap('<div class="prisma-input-group prisma-input-padding"><div>');
            $days.wrap('<div class="prisma-input-group prisma-input-padding"><div>');

            // Binds change event and update input
            $daysSelect.add($monthSelect).add($yearSelect).on('change', function() {
                if ($yearSelect.val() === '-1' || $monthSelect.val() === '-1' || $daysSelect.val() === '-1') {
                    $el.val('').blur();
                } else {
                    $el.val($yearSelect.val() + '-' + $monthSelect.val() + '-' + $daysSelect.val()).blur();
                }
            });
        }

        // Apply blur on enhanced input when blur in any select element
        if (!Odigeo._.isUndefined($daysSelect)) {
            $daysSelect.on('blur', function() {
                $el.blur();
            });
        }

        if (!Odigeo._.isUndefined($monthSelect)) {
            $monthSelect.on('blur', function() {
                $el.blur();
            });
        }

        if (!Odigeo._.isUndefined($yearSelect)) {
            $yearSelect.on('blur', function() {
                $el.blur();
            });
        }

        return $el;
    };

    Odigeo.UIElements.enhanceDateWithSelects.setDate = function($el, date) {
        $el = ($el instanceof $) ? $el : $($el);
        date = date.split('-');

        // Check if $el has everything ok to be created
        if (Odigeo._.isEmpty($el) ||
            $el.attr('data-skip-enhance') !== 'true' ||
            !Odigeo._.includes(['datePickerWith3Selects', 'datePickerWith2Selects', 'datePickerWith2Inputs'], $el.attr('data-role'))) {
            return;
        }

        switch ($el.attr('data-role')) {
            case 'datePickerWith3Selects':
                $el.nextAll('.odf-select-wrapper').find('.select_day').val(date[2]);
                $el.nextAll('.odf-select-wrapper').find('.select_month').val(date[1]);
                $el.nextAll('.odf-select-wrapper').find('.select_year').val(date[0]);
                break;
            case 'datePickerWith2Selects':
                $el.nextAll('.od-combomonth-input-wrapper').find('.select_month').val(date[1]);
                $el.nextAll('od-comboyear-input-wrapper').find('.select_year').val(date[0]);
                break;
            case 'datePickerWith2Inputs':
                $el.nextAll('.od-combomonth-input-wrapper').find('input').val(date[1]);
                $el.nextAll('.od-comboyear-input-wrapper').find('input').val(date[0]);
                break;
            default :
                return;
        }
    };

    Odigeo.UIElements.enhanceDateWithSelects.setCobaltDate = function($el, date) {
        $el = $el instanceof $ ? $el : $($el);
        date = date.split('-');

        // Check if $el has everything ok to be created
        if (
            Odigeo._.isEmpty($el) ||
            $el.attr('data-skip-enhance') !== 'true' ||
            !Odigeo._.includes(['datePickerWith3Selects', 'datePickerWith2Selects', 'datePickerWith2Inputs'], $el.attr('data-role'))
        ) {
            return;
        }

        switch ($el.attr('data-role')) {
            case 'datePickerWith3Selects':
                $el.nextAll('.od-cobalt-form-col-day')
                    .find('.select_day')
                    .val(date[2]);
                $el.nextAll('.od-cobalt-form-col-month')
                    .find('.select_month')
                    .val(date[1]);
                $el.nextAll('.od-cobalt-form-col-year')
                    .find('.select_year')
                    .val(date[0]);
                break;
            default:
                return;
        }
    };

    Odigeo.UIElements.enhanceDateWithSelects.setRange = function(el, latestDate, earliestDate) {
        var $el = (el instanceof $) ? el : $(el);
        var $inputWrapper = $el.parent();
        var yearInLoop;
        var $yearOptions;
        var $yearSelect;
        var $monthSelect;
        var $daySelect;

        // Leave only years within our range
        $yearOptions = $inputWrapper.find('.select_year option');
        Odigeo._.forEach($yearOptions, function(elem, i) {
            yearInLoop = elem.value;
            if (yearInLoop !== '-1' && (yearInLoop < earliestDate.getFullYear() || yearInLoop > latestDate.getFullYear())) {
                $yearOptions.eq(i).detach();
            }
        });

        // cache selects
        $yearSelect = $inputWrapper.find('.select_year');
        $monthSelect = $inputWrapper.find('.select_month');
        $daySelect = $inputWrapper.find('.select_day');

        // Save original HTML content of selects in case we need to detach some options
        $monthSelect.data('originalHTML', $monthSelect.html());
        $daySelect.data('originalHTML', $daySelect.html());

        // Attach event listeners
        $yearSelect.on('click.enhancedDateRange', Odigeo._.bind(
            makeSureMonthSelectHasValueInsideDateRange, window, earliestDate, latestDate, $yearSelect, $monthSelect, $daySelect));

        $monthSelect.on('click.enhancedDateRange', Odigeo._.bind(
            makeSureDaySelectHasValueInsideDateRange, window, earliestDate, latestDate, $yearSelect, $monthSelect, $daySelect));
    };

    function makeSureMonthSelectHasValueInsideDateRange(earliestPossibleDate, latestPossibleDate, $yearSelect, $monthSelect, $daySelect) {
        var currentYearValue = Number($yearSelect.val());
        var minMonthAllowed = 0;
        var maxMonthAllowed = 13;

        if (currentYearValue === earliestPossibleDate.getFullYear()) {
            minMonthAllowed = earliestPossibleDate.getMonth() + 1;
        } else if (currentYearValue === latestPossibleDate.getFullYear()) {
            maxMonthAllowed = latestPossibleDate.getMonth() + 1;
        }
        resetAndDetachOptionsWithValOutsideRange($monthSelect, minMonthAllowed, maxMonthAllowed);
        makeSureDaySelectHasValueInsideDateRange(earliestPossibleDate, latestPossibleDate, $yearSelect, $monthSelect, $daySelect);
    }

    function makeSureDaySelectHasValueInsideDateRange(earliestPossibleDate, latestPossibleDate, $yearSelect, $monthSelect, $daySelect) {
        var currentYearValue = Number($yearSelect.val());
        var currentMonthValue = Number($monthSelect.val());
        var minDayAllowed = 0;
        var maxDayAllowed = 31;

        if (currentYearValue === earliestPossibleDate.getFullYear() && currentMonthValue <= earliestPossibleDate.getMonth() + 1) {
            minDayAllowed = earliestPossibleDate.getDate();
        } else if (currentYearValue === latestPossibleDate.getFullYear() && currentMonthValue >= latestPossibleDate.getMonth() + 1) {
            maxDayAllowed = latestPossibleDate.getDate();
        }
        resetAndDetachOptionsWithValOutsideRange($daySelect, minDayAllowed, maxDayAllowed);
    }

    function resetAndDetachOptionsWithValOutsideRange($select, start, end) {
        var value = $select.val();
        $select.html($select.data('originalHTML'));
        $select.find('option').each(function(i, elem) {
            var $elem = $(elem);
            var val = $elem.val();
            if (val !== '-1' && (val < start || val > end)) {
                $elem.detach();
            }
        });
        $select.val(value);
        if ($select.val() !== value) {
            $select.val(-1);
        }
    }
}());
